export default __webpack_public_path__ + "static/media/bnsf.3e51ca6a.svg";